export default __webpack_public_path__ + "static/media/icon-check.640c8e12.svg";